<template>

  <!-- Page Body Block -->
  <page-block
    bg-image-contain
    v-if="hasContent"
    :bg-file="value.file"
    class="page-body-block"
    :bg-color="value.bgColor"
    :text-color="value.textColor"
    :text-align="value.textAlign"
    :width-class="value.widthClass"
    :overlay-class="value.paddingClass">

    <h1
      v-if="hasTitle"
      v-html="$u.nToBr(title)"/>

    <page-breadcrumbs/>

    <div
      v-if="hasBody"
      class="fr-view">

      <div
        v-html="body"/>

    </div>

  </page-block>

</template>

<script>

  import {mapState} from 'vuex';
  import PageBlock from 'components/page/page-block';
  import PageBlockMixin from '@src/mixins/page-block-mixin';
  import PageBreadcrumbs from 'components/page/page-breadcrumbs';

  export default {
    name: 'page-body-block',
    mixins: [
      PageBlockMixin,
    ],
    props: {
      value: {
        type: Object,
        required: true,
      },
    },
    components: {
      PageBreadcrumbs,
      PageBlock,
    },
    computed: {
      ...mapState('vlEvents', {
        event: 'item',
      }),
      ...mapState('vlNews', {
        newsItem: 'item',
      }),
      ...mapState('vlPages', {
        page: 'item',
      }),
      item() {

        return this.event
          || this.newsItem
          || this.page;
      },
      title() {

        return this.$u.localize(
          this.value.title,
        ) || this.$u.localize(
          (this.item || {}).title,
        );
      },
      body() {

        return this.$u.localize(
          this.value.body,
        ) || this.$u.localize(
          this.item.body,
        );
      },
      hasTitle() {

        return !!this.title;
      },
      hasBody() {

        return !!this.body;
      },
    },
  };

</script>

<style lang="scss">

  .page-body-block {
    color: inherit;

    .fr-view p:last-child {
      margin-bottom: 0;
    }
  }

</style>
